import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { AuditChange } from '../../../../../shared/models/audit/audit-change';
import { PreselectionService } from '../../../../services/preselection.service';
import { CommonUtils } from '../../../../common/common-utils';

@Component({
  selector: 'app-changes-table',
  imports: [],
  templateUrl: './changes-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './changes-table.component.scss',
})
export class ChangesTableComponent {
  @Input() public changes: AuditChange[] = [];
  public commonUtils = CommonUtils;

  private preselectionService = inject(PreselectionService);

  public navigateWithId(auditChange: AuditChange | null, old: boolean): void {
    if (!auditChange) {
      return;
    }

    const id = old ? auditChange.entityIdOld : auditChange.entityIdNew;
    if (!id) {
      return;
    }
    const searchTerm = old ? auditChange.oldVal : auditChange.newVal;
    this.preselectionService.configureAndChangeRoute(id, searchTerm ?? '', auditChange.entityType!);
  }
}
